import { css } from 'styled-components';

export default () => css`
  border: 0;
  overflow: visible;
  -webkit-appearance: button;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  cursor: pointer;
`;
